<div class="login-section">
  <div class="login-container">
    <div class="login-upper-section">
      <span class="login-title-text">Login to dp</span>
      <div class="content">
        <span class="login-content-text"
          >We’ve sent an authentication code to your phone ending with
          {{ maskedNo }}</span
        >
      </div>

      <div class="login-field-secton">
        <form [formGroup]="loginVerifyForm">
          <div class="input-field-container">
            <span class="input-level-text">Authentication code*</span>
            <div class="password-container">
              <input
                [type]="authenticationCodeVisible ? 'text' : 'password'"
                class="input-field dp-input-control"
                placeholder="Enter code"
                formControlName="authenticationCode"
                (keyup)="onInputBlur('authenticationCode')"
                (blur)="onInputBlur('authenticationCode')"
              />
              @if (loginVerifyForm.get('authenticationCode')?.value) {
              <div
                class="password-icon"
                [ngStyle]="{
                  'background-image': authenticationCodeVisible
                    ? 'var(' + visibilityOnIcon + ')'
                    : 'var(' + visibilityOffIcon + ')'
                }"
                (click)="toggleauthCodeVisibility()"
              ></div>
              }
            </div>
            <!-- @if (authenticationCodeVisible) {
            <span class="error-message"> Enter a valid code </span>
            } -->
          </div>

          <button class="login-button dp-primary-btn" (click)="secondAPIcall()">
            Login
          </button>
        </form>
        @if (!isSpanDisabledForMobile) {
        <span class="resend" (click)="onResendForMobile()">Resend Code</span>
        } @if (isSpanDisabledForMobile) {
        <span class="resend-countdown">
          Resend in {{ countdownForMobile }}
        </span>
        }
      </div>
    </div>
    <div class="footer-section">
      <div class="registration-ask-text">Not registered with DP Works?</div>
      <a [routerLink]="'/create-account'" class="registration-now-text"
        >Register now</a
      >
    </div>
  </div>
</div>
